// RouteFallback (R5-02) — Suspense-Geruest fuer JEDEN Routenwechsel.
//
// Vorher stand in routes.tsx `<Suspense fallback={null}>`: solange der
// Chunk-Graph der Zielroute lud, ersetzte React den gesamten <Routes>-Baum
// durch NICHTS, und der Nutzer sah die nackte Body-Flaeche — im Browser
// gemessen 1.031 ms auf Kabel, auf Mobilfunk mit kaltem Cache zweistellige
// Sekunden (Diagnose B1-4, Befund 3). Genau das war Julius' „leerer
// dunkelblauer Screen" nach dem Abenteuer-Start.
//
// Bewusst OHNE i18n-Text: das Geruest kann geladen werden, bevor die
// Sprachdateien da sind, und ein falsch aufgeloester Schluessel waere
// schlimmer als eine reine Form. Ein `role="status"` mit `aria-busy` sagt
// Screenreadern trotzdem, dass gerade etwas geladen wird.

import { Skeleton } from '../components/ui/Skeleton';
import styles from './RouteFallback.module.css';

export function RouteFallback() {
  return (
    <div className={styles.wrap} role="status" aria-busy="true">
      <div className={styles.header}>
        <Skeleton variant="avatar" size="sm" />
        <Skeleton variant="line" className={styles.headerTitle} />
      </div>
      <div className={styles.body}>
        <div className={styles.block}>
          <Skeleton variant="line" length="medium" />
          <Skeleton variant="line" />
          <Skeleton variant="line" length="long" />
        </div>
        <div className={styles.block}>
          <Skeleton variant="line" length="short" />
          <Skeleton variant="line" />
          <Skeleton variant="line" length="medium" />
        </div>
      </div>
    </div>
  );
}

export default RouteFallback;
